import { CustomerFlagId, CustomerFlagType, DeliveryMethodId, PaymentMethodId } from "../../common/enum";

export interface AdminListEditDto {
    code: string;
    description: string;
    id: number | null;
}

export interface AdminListItemDto {
    id: number;
    code: string;
    description: string;
}

export interface CollectionAgencyEditDto {
    id: number | null;
    name: string;
}

export interface CollectionAgencyDto {
    id: number;
    name: string;
}

export const newCollectionAgency: () => CollectionAgencyEditDto = () => ({
    id: null,
    name: "",
});

export interface CustomerNoteActionTypeEditDto {
    id: number | null;
    name: string;
    code: string,
    active: boolean;
    priority: number;
    priorityFormatted?: string;
}

export interface CustomerNoteActionTypeDto {
    id: number;
    name: string;
    code: string,
    active: boolean;
    priority: number
}

export const newCustomerNoteActionType: () => CustomerNoteActionTypeEditDto = () => ({
    id: null,
    name: "",
    code: "",
    active: true,
    priority: 1,
});

export interface CustomerNoteTypeEditDto {
    id: number | null;
    name: string;
    code: string;
    active: boolean;
    priority: number;
    priorityFormatted?: string;
}

export interface CustomerNoteTypeDto {
    id: number;
    name: string;
    code: string;
    active: boolean;
    priority: number
}

export const newCustomerNoteType: () => CustomerNoteTypeEditDto = () => ({
    id: null,
    name: "",
    code: "",
    active: true,
    priority: 1,
});

export interface PrintTemplateEditDto {
    id: number | null;
    name: string;
    template: string;
}

export interface PrintTemplateDto {
    id: number;
    name: string;
    template: string;
}

export const newPrintTemplate: () => PrintTemplateEditDto = () => ({
    id: null,
    name: "",
    template: "",
});

export interface DefaultValuesDto {
    numberFormat: string;
    landCode: string;
    language: string;
    showEurAr: boolean;
    euroRate: number;
    mailId: number;
    currency: string;
    fstPstAmt: number;
    fstPstPct: number;
    nrmPstPct: number;
    nrmPstAmt: number;
    dummyCust: string;
    retCnt: number;
    address: string;
    addressMale: string;
    addressFemale: string;
    addressLong: string;
    addressLongMale: string;
    addressLongFemale: string;
    boxWt: number;
    envelopeWt: number;
    letterPath: string;
    maxVatDisc: number;
    ret1Rs: boolean;
    packCost: number;
    maxDunLvl: number;
    minVersion: string;
    defCa: number;
    businessPlace: number;
    companyId: string;
    waveNr: number;
    ofrIn1Rs: boolean;
    allowComgatePaymentLinks: boolean;
    chkOffset: number;
    isTmOrderConfirmationRequired: boolean;
    woOnlyUnconfirmed: boolean;
    reservationTransactionCodeId: number | null;
    reservationWarehouseId: number | null;
    shipmentTransactionCodeId: number | null;
    shipmentWarehouseId: number | null;
    customerReturnTransactionCodeId: number | null;
    customerReturnWarehouseId: number | null;
    postalReturnTransactionCodeId: number | null;
    postalReturnWarehouseId: number | null;
    allowedPaymentMethodLimit: number | null;
    businessCenterEmailAddress: string;
    overweightOrderEmailText: string;
    overweightOrderEmailSubjectText: string;
    codRoundingThreshold: number;
}

export interface SpecialActionDto {
    id: number;
    template1OfferMailOrderShipmentId: number | null;
    template2OfferMailOrderShipmentId: number | null;
    template3OfferMailOrderShipmentId: number | null;
    name: string;
    description: string;
    fromDate: string;
    toDate: string
}

export interface SpecialActionEditDto {
    id: number | null;
    template1OfferMailOrderShipmentId: number | null;
    template2OfferMailOrderShipmentId: number | null;
    template3OfferMailOrderShipmentId: number | null;
    name: string;
    description: string;
    fromDate: string;
    fromDateFormatted?: string;
    toDate: string;
    toDateFormatted?: string;
}

export const newSpecialAction: () => SpecialActionEditDto = () => ({
    id: null,
    template1OfferMailOrderShipmentId: null,
    template2OfferMailOrderShipmentId: null,
    template3OfferMailOrderShipmentId: null,
    name: "",
    description: "",
    fromDate: "",
    toDate: ""
});

export interface PaymentMethodDto {
    id: PaymentMethodId;
    code: string;
    description: string;
    active: boolean;
}

export interface DeliveryMethodDto {
    id: DeliveryMethodId;
    code: string;
    description: string;
    isActive: boolean;
    isDefault: boolean;
    mfHomeDeliveryText: string;
    mfPickUpPointDeliveryText: string;
    lastRefresh?: string;
    generatePostNr: boolean;
    isCodPickupPointAllowed: boolean;
    preferMobileOverEmail: boolean;

    glsXmlSenderId: string;
    glsXmlExpSenderId: string;
    glsXmlFromName: string;
    glsXmlFromAddress: string;
    glsXmlFromZipCode: string;
    glsXmlFromCity: string;
    glsXmlFromCtrCode: string;
    glsXmlFromContactName: string;
    glsXmlFromContactPhone: string;
    glsXmlFromEmailAddress: string;
    glsStickerSenderLine1: string;
    glsStickerSenderLine2: string;
    glsStickerSenderLine3: string;
    glsStickerSenderLine4: string;
    glsStickerSenderLine5: string;
    glsStickerSenderLine6: string;

    glsLastPostNr: number | null;

    dpdFromName: string;
    dpdFromPhone: string;
    dpdFromEmailAddress: string;
    dpdFromAddress: string;
    dpdFromCity: string;
    dpdFromZipCode: string;
    dpdFromCtrCode: string;

    defaultSeqTypMo: string;
    defaultLastPostNrMo: number | null;
    defaultUseMoSeq: boolean;
    defaultSeqTypMaxi: string;
    defaultSeqTypMoMaxi: string;
    defaultSeqStartMaxi: string;
    defaultSeqEndMaxi: string;
    defaultSeqStart: string;
    defaultSeqEnd: string;
    defaultLastPostNrMaxi: number | null;
    defaultLastPostNrMoMaxi: number | null;
    defaultLastPostNr: number | null;
    defaultSeqTyp: string;
    defaultAtmUseMaxiSeq: boolean;
    defaultUseMaxiSeq: boolean;
    defaultUseMaxiMoSeq: boolean;

    pickUpPointWeightLimit: number | null;
    homeDeliveryWeightLimit: number | null;
}

export interface ReplacementArticleDto {
    id: number;
    saleArticleId: number;
    description: string | null;
    price: number | null;
    isActive: boolean;
    details: ReplacementArticleDetailDto[];
}

export interface ReplacementArticleDetailDto {
    id: number;
    saleArticleId: number;
    priority: number;
    oldQuantity?: number;
    newQuantity?: number;
    price?: number;
}

export interface ReplacementArticleEditDto extends Partial<ReplacementArticleDto> {
    priceFormatted?: string;
}

export interface ReplacementArticleDetailEditDto extends Partial<ReplacementArticleDetailDto> {
    priorityFormatted?: string;
    oldQuantityFormatted?: string;
    newQuantityFormatted?: string;
    priceFormatted?: string;
}

export interface CustomerStopCodeDto {
    id?: CustomerFlagId;
    idFormatted?: string;
    code: string;
    name: string;
    isActive: boolean;
    type?: CustomerFlagType;
}

export interface CallCenterDto {
    id?: number;
    name: string;
    isActive: boolean;
    projects: { [id: number]: CallCenterProjectDto; };
    hideCherrypickData: boolean;
    codForUnconfirmed: boolean;
    apiTokens: string;
}

export interface CallCenterProjectDto {
    projectId: number;
    activeFrom: string | null;
    activeTo: string | null;
    fixPackagePrice?: number;
    fixSmallPackagePrice?: number;
    fixIndividualPrice?: number;
    packageValuePercent?: number;
    individualValuePercent?: number;
    smallPackageValuePercent?: number;
    fixArticlePrice?: number;
    fixOrderPrice?: number;
}

export interface TmCallResultDto {
    id: number;
    code: string;
    name: string;
    position: number;
    isActive: boolean;
}

export interface TmCallResultEditDto {
    id: number | null;
    code: string;
    name: string;
    position: number;
    positionFormatted?: string;
    isActive: boolean;
}

export interface EPrefItemDto {
    id: number;
    name: string;
    code: string;
    isActive: boolean;
    isUnique: boolean | null;
    priority: number
}

export interface EPrefItemEditDto {
    id: number | null;
    name: string;
    code: string;
    isActive: boolean;
    isUnique: boolean | null;
    priority: number;
    priorityFormatted?: string;
}

export const newEPrefItem: () => EPrefItemEditDto = () => ({
    id: null,
    name: "",
    code: "",
    isUnique: false,
    isActive: true,
    priority: 1,
});